import { render, staticRenderFns } from "./simple-list.vue?vue&type=template&id=48ce4bdc"
import script from "./simple-list.vue?vue&type=script&lang=js"
export * from "./simple-list.vue?vue&type=script&lang=js"
import style0 from "./simple-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports